module.exports = __webpack_public_path__ + "static/media/4.5d89269c.jpg";